import styled, { css } from 'styled-components';
import { CNDStyledTextSpan } from '../../../pages/shared/CIPage/ui';

const LegalText = styled(CNDStyledTextSpan)<{ isBefore?: boolean }>`
    ${props =>
        css`
            & p {
                cursor: not-allowed;
                padding-left: 24px;
                padding-${props.isBefore ? 'bottom' : 'top'}: 8px;
                color: rgba(0, 0, 0, 0.25);
            }
          `}
`;

export default LegalText;
